import { useSessionStore, useAppStore } from '@/stores'
import { jsonRpc } from '@communication'

export default class BackendNotificationProcedure {
  constructor() {
    this.name = 'backendNotificationProcedure'
    this.session = useSessionStore()
    this.app = useAppStore()
    window.test = this.test
  }

  install = () => {
    jsonRpc.on('plt:notification', this.handler)
  }

  uninstall = () => {
    jsonRpc.off('plt:notification', this.handler)
  }

  handler = (event) => {
    // event.detail is the JSON-RPC params = the backend body {action, payload}; a {notification} wrapper is accepted too
    const notification = event.detail?.notification ?? event.detail
    if (!notification) return
    switch (notification.action) {
      case 'participantsChanged': {
        const { changes, participants } = notification.payload ?? {}
        if (changes !== undefined && Array.isArray(changes.addedObservers) && Array.isArray(participants)) {
          const addedObservers = participants.filter((participant) => participant && changes.addedObservers.includes(participant.partyId))
          addedObservers.forEach((addedObserver) => {
            delete addedObserver.partyId
            // already in the list (join-time info or an earlier notification): keep that entry
            if (this.session.getParticipantInfo(addedObserver.id)) return
            this.session.createParticipant(addedObserver)
          })
        }
        break
      }
    }
  }
}
